import React, { useEffect, useState } from "react";
import { Table, Avatar } from "antd";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { dashboardPMSApis } from "../../../api/DashboardPMS";

interface IssueTeamStatusData {
  projectId: number;
  issueAssignedTo: number;
  name: string;
  initials: string;
  color?: string;
  issueOverdue: number;
  issueToday: number;
  issueAllOpen: number;
}

const initialsColor = (initials: string) => {
  const palette = [
    "#f56a00",
    "#7265e6",
    "#00a2ae",
    "#ffbf00",
    "#87d068",
    "#1677ff",
    "#eb2f96",
  ];
  const code = (initials || "")
    .split("")
    .reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return palette[code % palette.length];
};

const IssueTeamStatusTable: React.FC<{ id: number }> = ({ id }) => {
  const [rows, setRows] = useState<IssueTeamStatusData[]>([]);

  const fetchIssueTeamStatus = async () => {
    try {
      const apiResponse: ApiResponse =
        await dashboardPMSApis.fetchIssueStatusByTeamMemberDashBoard(
          id,
          "issueStatusByTeamMember"
        );
      const { data, status } = apiResponse;
      if (status && Array.isArray(data)) {
        setRows(data);
      } else {
        setRows([]);
      }
    } catch (error) {
      console.log(error);
      setRows([]);
    }
  };

  useEffect(() => {
    if (id) fetchIssueTeamStatus();
  }, [id]);

  const columns = [
    {
      title: "Users",
      dataIndex: "name",
      key: "name",
      render: (_: string, record: IssueTeamStatusData) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            style={{
              backgroundColor: record.color || initialsColor(record.initials),
              fontSize: 12,
            }}
          >
            {record.initials}
          </Avatar>
          <span>{record.name}</span>
        </div>
      ),
    },
    {
      title: <span style={{ color: "red" }}>Overdue</span>,
      dataIndex: "issueOverdue",
      key: "issueOverdue",
      render: (value: number) => (
        <span style={{ color: value > 0 ? "red" : undefined }}>{value}</span>
      ),
    },
    {
      title: "Today's",
      dataIndex: "issueToday",
      key: "issueToday",
    },
    {
      title: "All Open",
      dataIndex: "issueAllOpen",
      key: "issueAllOpen",
    },
  ];

  return (
    <div style={{ position: "relative", height: "100%" }}>
      <Table
        rowKey={(record) =>
          `${record.projectId}-${record.issueAssignedTo}-${record.name}`
        }
        columns={columns}
        dataSource={rows}
        pagination={false}
        size="middle"
        bordered={false}
        scroll={{ y: 250 }}
        components={{
          header: {
            cell: (props: any) => (
              <th
                {...props}
                style={{
                  ...props.style,
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fafafa",
                  zIndex: 1,
                  borderBottom: "1px solid #f0f0f0",
                }}
              />
            ),
          },
        }}
        style={{ height: "100%" }}
      />
    </div>
  );
};

export default IssueTeamStatusTable;
